module.exports = __webpack_public_path__ + "static/media/logo-horizontal-white.a12de93b.png";